<template>
  <div class="rf-field rf-textarea" :class="computedClass">

    <!-- Slot for custom label markup -->
    <slot>
      <label :for="name" class="rf-label">{{ label }}</label>
    </slot>

    <div class="rf-input">
      <textarea v-bind="{ name, rows, disabled, placeholder }" :id="name" v-model="value" v-validate="validation" @blur="onBlur" ref="input"></textarea>
      <transition name="fade-fast">
        <icon name="exclamation-triangle" class="rf-icon rf-icon-invalid" v-if="showInvalid" key="invalid"></icon>
        <icon name="check" class="rf-icon rf-icon-valid" v-else-if="showValid" key="valid"></icon>
      </transition>
      <!-- Errors -->
      <rf-message v-if="showInvalid">{{ errors.first(name) }}</rf-message>
    </div>
  </div>

</template>

<script>
import mixins from '../mixins/index'

export default {
  name: 'RfTextrea',
  mixins: mixins,
  props: {
    rows: {
      type: [Number, String],
      required: false,
      default: 8
    },
    placeholder: {
      type: String,
      default: ''
    },
    initialValue: {
      type: String,
      default: null
    }
  },
  mounted () {
    // Set initial value and validate
    if (this.initialValue) {
      this.value = this.initialValue
      this.$validator.validate(this.name, this.value)
    }
  },
  methods: {
    onBlur () {
      this.isDirty = this.fields[this.name].dirty || !!this.initialValue
      if (this.isDirty) {
        this.validate()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// RfTextarea.vue?015e0b91